const htmlContent = `
<div id="markdown">
<h1 id="das-terraform-statefile-aws">Das Terraform-Statefile: AWS</h1>
<p>Dies ist Teil 3 von
<a href="/terraform-statefile">Das Terraform-Statefile in Public Clouds</a> und behandelt AWS.  </p>
<h2 id="schnellstart">Schnellstart</h2>
<ol>
<li>Klonen Sie <a href="https://github.com/ludwigprager/aws-terraform-base">dieses Repo</a>.<pre><code> git clone https://github.com/ludwigprager/aws-terraform-base
</code></pre>
</li>
<li>Tragen Sie Ihre Zugangsdaten in <code>~/.aws/credentials</code> ein und rufen Sie auf<pre><code>./aws-terraform-base/10-deploy.sh
</code></pre>
</li>
</ol>
<h2 id="zusammenfassung">Zusammenfassung</h2>
<p>Die Befehle sind fast identisch mit <a href="/terraform-statefile-gcp">Teil 2</a> über GCP.
Die Erstellung des Backends mit dem Statefile unterscheidet sich jedoch grundlegend.</p>
<h2 id="schritt-1-20-tf-backend10-createsh">Schritt 1: 20-tf-backend/10-create.sh</h2>
<p>Erstellt den Container für das Statefile, falls er noch nicht existiert.<br>Das Vorgehen ist deutlich umfangreicher als die <a href="https://www.celp.de/terraform-statefile-gcp">GCP-Version</a>.
Es folgt dem von AWS empfohlenen Ansatz und nutzt eine DynamoDB-Tabelle zur Synchronisation.<br><a href="https://github.com/ludwigprager/aws-terraform-base/blob/main/20-tf-backend/10-create.sh">Hier die Datei auf github</a></p>
<h2 id="schritt-2-30-main10-applysh">Schritt 2: 30-main/10-apply.sh:</h2>
<p>Zuletzt wird Terraform gestartet, nachdem alle Vorbereitungen abgeschlossen sind.
<code>terraform init</code> ändert bei erneutem Aufruf nichts,
aber <code>terraform apply</code> ändert alle Ressourcen gemäß den .tf-Dateien.<br><a href="https://github.com/ludwigprager/aws-terraform-base/blob/main/30-main/10-apply.sh">Diese Datei auf github</a></p>
<pre><code>source ../set-env.sh

terraform init \
  -input=false \
  -backend-config=&quot;bucket=\${BUCKET_NAME}&quot; \
  -backend-config=&quot;region=\${TF_VAR_backend_region}&quot; \
  -backend-config=&quot;dynamodb_table=\${DYNAMODB_TABLE}&quot;

terraform apply -auto-approve
</code></pre>
<h2 id="die-tf-dateien">Die .tf-Dateien</h2>
<p>Diese Dateien enthalten die Definition der Ressourcen, die Terraform erzeugen soll.<br>In diesem Teil ist es der Einfachheit halber nur eine Registry.</p>
<p>30-main/backend.tf:</p>
<pre><code>terraform {  
    backend &quot;s3&quot; {
        encrypt        = true
        key            = &quot;poc1/terraform.tfstate&quot;
    }
}
</code></pre>
<p>30-main/provider.tf:</p>
<pre><code>provider &quot;aws&quot; {
  profile = &quot;default&quot;
  region  = var.aws_region
}

terraform {
  required_providers {
    aws = {
      source  = &quot;hashicorp/aws&quot;
      version = &quot;&gt;= 3.40&quot;
    }
  }
}
</code></pre>
<p>30-main/main.tf:</p>
<pre><code>resource &quot;aws_ecr_repository&quot; &quot;repo&quot; {
  name                 = &quot;g1&quot;
}
</code></pre>
<p>30-main/network-variables.tf:</p>
<pre><code>variable &quot;aws_region&quot; {
  description = &quot;AWS region&quot;
  type        = string
  default     = &quot;eu-central-1&quot;
}
</code></pre>

</div>
`;
export default htmlContent
